export const decimalMask = value => {
  if (!value) return "";

  // Remove tudo que não é dígito ou vírgula
  let cleanValue = value.toString().replace(/[^\d,]/g, "");

  // Permite apenas uma vírgula (mantém a primeira, remove as demais)
  const firstCommaIndex = cleanValue.indexOf(",");
  if (firstCommaIndex !== -1) {
    cleanValue =
      cleanValue.substring(0, firstCommaIndex + 1) +
      cleanValue.substring(firstCommaIndex + 1).replace(/,/g, "");
  }

  return cleanValue;
};

export const convertToFloat = value => {
  if (!value || value === "") return 0;
  // Converte vírgula para ponto e transforma em float
  const floatValue = parseFloat(value.toString().replace(",", "."));
  return isNaN(floatValue) ? 0 : floatValue;
};
